import type { GuidanceResponse, Task } from '@core/fhir-r4/fhir';
import type { DownstreamFailureReason } from '@core/ports/DownstreamFailureReason';

export interface PreTriageGatewayBundleResource {
  resourceType?: string;
  [key: string]: unknown;
}

export interface PreTriageGatewayBundleEntry {
  resource?: PreTriageGatewayBundleResource;
}

export interface PreTriageGatewayBundle {
  resourceType?: string;
  entry?: readonly PreTriageGatewayBundleEntry[];
}

export interface PreTriageGatewayResult {
  guidanceResponse: GuidanceResponse;
  bundle?: PreTriageGatewayBundle;
  backendJoinKey?: string;
}

export type PreTriageGatewayErrorCode = 'commit-ambiguous-stop' | 'offline' | 'request-failed' | 'retry-exhausted' | 'session-required';

export class PreTriageGatewayError extends Error {
  public constructor(
    public readonly code: PreTriageGatewayErrorCode,
    message: string,
    public readonly failureReason?: DownstreamFailureReason,
  ) {
    super(message);
    this.name = 'PreTriageGatewayError';
  }
}

export interface PreTriageGateway {
  applyTask(taskPayload: Task): Promise<PreTriageGatewayResult>;
}